.skeletonContent {
  margin-top: 48px;
  .skeletonPlaceholder {
    width: 100%;
    height: 38px;
    margin-bottom: 24px;
  }
  .skeletonPlaceholderSmall {
    width: 70px;
  }
  .skeletonPlaceholderTiny {
    width: 30px;
  }
}
